import { AnimatedImage } from "./animated-image";
import { cn } from "@/lib/utils";

type Size = "sm" | "md" | "lg";

const sizeClasses: Record<Size, { box: string; text: string }> = {
  sm: { box: "h-4 w-4", text: "text-[8px]" },
  md: { box: "h-5 w-5", text: "text-[9px]" },
  lg: { box: "h-9 w-9", text: "text-xs" },
};

interface WorkspaceIconProps {
  name: string;
  logoUrl?: string | null;
  slug?: string | null;
  size?: Size;
  className?: string;
}

export function WorkspaceIcon({
  name,
  logoUrl,
  slug,
  size = "md",
  className,
}: WorkspaceIconProps) {
  const hasLogo = Boolean(logoUrl?.trim());
  const isAno =
    !hasLogo && (slug === "ano" || name?.trim().toLowerCase() === "ano");
  const s = sizeClasses[size];

  if (hasLogo || isAno) {
    return (
      <div
        className={cn(
          s.box,
          "rounded bg-sidebar flex items-center justify-center overflow-hidden",
          className,
        )}
      >
        <AnimatedImage
          src={hasLogo ? (logoUrl ?? undefined) : "/workspace-logo.webp"}
          alt={name}
          className={s.box}
        />
      </div>
    );
  }

  return (
    <div
      className={cn(
        s.box,
        // Letter-bubble fallback for workspaces without a logo. `bg-foreground/60`
        // gives a muted bubble that adapts to either theme; pairing it with
        // `text-background` ensures the initial reads on both — without this
        // the letter inherits the surrounding sidebar color and goes dark-on-dark
        // in matcha2-light.
        "rounded bg-foreground/60 text-background flex items-center justify-center font-semibold",
        s.text,
        className,
      )}
    >
      {(name || "?").charAt(0).toUpperCase()}
    </div>
  );
}
